export var getDiscountStatus = function (price, accessoryPrices) {
    if (!price) {
        return false;
    }
    var productHasDisctount = price.isDiscounted
        || price.c_isDiscounted;
    if (!accessoryPrices) {
        return productHasDisctount;
    }
    var accessoryHasDictount = accessoryPrices === null || accessoryPrices === void 0 ? void 0 : accessoryPrices.some(function (accessory) {
        var sfcc = accessory;
        var productPrice = accessory;
        return sfcc.c_isDiscounted || productPrice.isDiscounted;
    });
    return accessoryHasDictount;
};
